module.exports = __webpack_public_path__ + "static/media/ic_launcher.2c20f5fe.png";